<script>
import dateFormat from "@/shared/lib/date-format";
import InformationLayout from "@/shared/ui/information-layout/InformationLayout.vue";
import SelectReference from "@/pages/admin/tariffs/components/SelectReference.vue";
import { FormItem, FormLabel, FormControl } from "@/shared/ui/form";
import { Input } from "@/shared/ui/input";
import { ChevronDown } from "lucide-vue-next";

export default {
  name: "TariffData",
  components: {
    InformationLayout,
    SelectReference,
    FormItem,
    FormLabel,
    FormControl,
    Input,
    ChevronDown,
  },
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    selectedTariff: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      loading: false,
      showSelectDrawer: false,
    };
  },
  computed: {
    uuid() {
      return this.$route.params.id;
    },
    showForm() {
      return (
        this.$route.name === "benefit_new" ||
        this.$route.name === "benefit_item"
      );
    },

    sections() {
      if (!this.selectedTariff) return [];

      const tariff = this.selectedTariff;

      return [
        {
          title: this.$t("Данные льготы"),
          items: [
            {
              label: this.$t("Наименование льготы"),
              values: [
                { lang: "Рус", text: tariff.name },
                { lang: "Қаз", text: tariff.name_kz },
              ],
            },
            {
              label: this.$t("Дата создания"),
              values: [{ text: this.dateFormat(tariff.created_at) }],
            },
            {
              label: this.$t("Категория нотариального действия"),
              values: [{ text: tariff.codes?.length }],
            },
            {
              label: this.$t("Стоимость скидки"),
              values: [
                {
                  text: tariff.discount_value || "-",
                },
              ],
            },
          ],
        },
      ];
    },

    displayValue() {
      return this.form?.codes.length
        ? this.$t("Выбрано: {count}", { count: this.form?.codes.length })
        : "";
    },
  },
  methods: {
    async validate() {
      return true;
    },
    dateFormat(date) {
      if (!date) {
        return this.$t("Не указано");
      }
      return dateFormat.timestamp_to_local_tz(date, "DD.MM.YYYY, HH:mm");
    },
  },
};
</script>

<template>
  <div class="block">
    <div v-if="showForm" class="flex flex-col gap-8 w-full">
      <div class="flex flex-col gap-3">
        <div class="text-foreground text-lg font-semibold leading-6">
          {{ $t("Параметры льгот") }}
        </div>
      </div>

      <div class="flex flex-col gap-3">
        <form class="flex flex-col gap-1">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
            <FormItem float>
              <FormLabel>{{ $t("Наименование льготы (рус)") }}</FormLabel>
              <FormControl>
                <Input v-model="form.name" placeholder="" />
              </FormControl>
            </FormItem>

            <FormItem float>
              <FormLabel>{{ $t("Наименование льготы (қаз)") }}</FormLabel>
              <FormControl>
                <Input v-model="form.name_kz" placeholder="" />
              </FormControl>
            </FormItem>
          </div>

          <div class="grid grid-cols-1 gap-6">
            <FormItem float>
              <FormLabel>{{
                $t("Категория нотариального действия")
              }}</FormLabel>
              <FormControl>
                <div class="relative">
                  <Input
                    :model-value="displayValue"
                    readonly
                    :placeholder="$t('Выберите')"
                    class="cursor-pointer pr-8"
                    @click="showSelectDrawer = true"
                  />
                  <ChevronDown
                    class="absolute right-2 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground cursor-pointer"
                    @click="showSelectDrawer = true"
                  />
                </div>
              </FormControl>
            </FormItem>
          </div>

          <div class="grid grid-cols-1 gap-6">
            <FormItem float>
              <FormLabel>{{ $t("Стоимость скидки") }}</FormLabel>
              <FormControl>
                <Input
                  v-model="form.discount_value"
                  :placeholder="$t('Введите значение от 0 до 100 %')"
                  class="w-full"
                />
              </FormControl>
            </FormItem>
          </div>
        </form>
      </div>
    </div>
    <div v-if="$route.name === 'benefit_item_view'">
      <InformationLayout :showHeader="false" :sections="sections" />
    </div>

    <SelectReference
      v-if="showSelectDrawer"
      :form="form"
      @close="showSelectDrawer = false"
      @save="showSelectDrawer = false"
    />
  </div>
</template>

<style scoped lang="scss">
.block {
  @apply h-full w-1/2 overflow-auto bg-card rounded-2xl p-8;
}

@media (max-width: 1400px) {
  .block {
    @apply w-full;
  }
}
</style>
